<form class="app-flex-form" (click)="debugForm(constructor.name)" (keydown)="(null)">
  @for (filter of filters(); track $index) {
    @if (currentFilterView() === filter.label && filter.column === fileAdminFilterKey.State) {
      <mat-selection-list [formField]="formTree.state">
        @for (state of stateValues; track $index) {
          <mat-list-option [value]="state" (click)="$event.stopPropagation()">
            {{ state | stateStatusDisplay }}
          </mat-list-option>
        }
      </mat-selection-list>
    } @else if (currentFilterView() === filter.label && filter.column === fileAdminFilterKey.Purpose) {
      <mat-selection-list [formField]="formTree.purpose">
        @for (purpose of filePurposeValues; track $index) {
          <mat-list-option [value]="purpose" (click)="$event.stopPropagation()">
            {{ purpose | filePurposeDisplay }}
          </mat-list-option>
        }
      </mat-selection-list>
    } @else if (currentFilterView() === filter.label && filter.column === fileAdminFilterKey.Mimetype) {
      <mat-selection-list [formField]="formTree.mimeType">
        @for (mimePrefix of mimePrefixes; track $index) {
          <mat-list-option [value]="mimePrefix" (click)="$event.stopPropagation()">
            {{ mimePrefix }}
          </mat-list-option>
        }
      </mat-selection-list>
    }
  }
</form>
